var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5220",
    "data-name": "Group 5220",
    transform: "translate(-10 -732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5214",
    "data-name": "Group 5214",
    transform: "translate(0 -24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1480",
    "data-name": "Rectangle 1480",
    width: 81,
    height: 81,
    rx: 40.5,
    transform: "translate(10 756)",
    fill: "#1e222f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Weight-Loss",
    d: "M40.36,4.538H31.618a5.591,5.591,0,0,0-1.066-1.919A5.807,5.807,0,0,0,26.074.7H15.2a5.807,5.807,0,0,0-4.478,1.919A4.337,4.337,0,0,0,9.442,4.538H.7V40.147H40.147V4.538Zm-27.293.213c.213-.213,1.066-1.066,1.706-1.066h11.3c.64,0,1.279.853,1.493,1.279a2,2,0,0,1,.213,1.919l-.213,9.6h-6.61l1.919-4.9c.426-1.066.64-1.919-.213-2.346s-1.493,0-1.919,1.066l-2.772,6.4H13.28L12.428,6.67C12.214,6.244,12.641,5.178,13.067,4.751ZM37.375,7.1V37.588H3.685V7.1H9.442l.853,8.1c.426,2.985,2.985,4.265,5.97,4.265h8.742c2.985,0,5.544-1.279,5.97-4.265l.853-8.1ZM24.582,28.206h-8.1a1.919,1.919,0,0,0,0,3.838h7.889a1.911,1.911,0,0,0,1.919-1.919A1.725,1.725,0,0,0,24.582,28.206Z",
    transform: "translate(30.3 776.353)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.6c49a099a3882c65b2e488339cfa4d4f.svg";
export { ForwardRef as ReactComponent };